module.exports = __webpack_public_path__ + "img/api_introduction.e92b3dec.svg";